import React, { useState, useRef, useEffect } from 'react';
import Channels from '../NotificationThreadListHeader/Channels';
import ChannelFilter from '../NotificationThreadListHeader/ChannelFilter';
import { Col } from 'react-bootstrap';
import { IoIosArrowDown, IoMdAdd } from "react-icons/io";
import { GrSearch } from 'react-icons/gr';
import { CgClose } from 'react-icons/cg';
import button from '../Style/ButtonStyle.module.css';
import jQuery from "jquery";

interface NotificationThreadListHeaderProps {
    selectedChannels: string[];
    onComposeChannels: (channels: string[]) => void;
    resetChannelsHandler: () => void;
    selectedChannelFilter: string[];
    applyChannelFilterHandler: (filters: string[]) => void;
    resetChannelFilterHandler: () => void;
    deactivateNotificationHandler?: (id: string) => void;
    clearRecipientsSelection: () => void;
    applySearchText: (searchText: string) => void;
    isSearching?: boolean;
}

const NotificationThreadListHeader: React.FC<NotificationThreadListHeaderProps> = ({
    selectedChannels,
    onComposeChannels,
    resetChannelsHandler,
    selectedChannelFilter,
    applyChannelFilterHandler,
    resetChannelFilterHandler,
    deactivateNotificationHandler,
    clearRecipientsSelection,
    applySearchText,
    isSearching = false
}) => {
    const ref = useRef<any>(null);
    const [isShowChannels, setIsShowChannels] = useState(false);
    const [isChannelFilter, setIsChannelFilter] = useState(false);
    const [isDeactivateNotificationOpne, setIsDeactivateNotificationOpne] = useState(false);
    const [isDeactivateNotificationFilter, setIsDeactivateNotificationFilter] = useState(false);
    const [selectedChannelsForValidation, setSelectedChannelsForValidation] = useState<string[]>([]);
    const [searchFilter, setSearchFilter] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    // jQuery event handler for outside clicks
    useEffect(() => {
        jQuery(document).on('click touched', function (e) {
            if (jQuery(e.target).parents().hasClass("channelBox")) {
                e.stopPropagation();
            } else if (jQuery(e.target).parents().hasClass("selectfilter")) {
                e.stopPropagation();
            } else if (jQuery(e.target).hasClass("emojionearea")) {
                e.stopPropagation();
            } else if (jQuery(e.target).parents().hasClass("emojionearea")) {
                e.stopPropagation();
            } else {
                setIsShowChannels(false);
                setIsChannelFilter(false);
            }
        });

        return () => {
            jQuery(document).off('click touched');
        };
    }, []);

    const openFilterHandler = () => {
        setSearchFilter(true);
        setSearchValue(''); // Reset search value when opening
    };

    const closeFilterHandler = () => {
        setSearchFilter(false);
        setSearchValue(''); // Clear local search value
        applySearchText(''); // Clear search text when closing
    };

    const clearFilterNotification = () => {
        resetChannelFilterHandler();
    };

    const selectChannelHandler = () => {
        console.log("selectedChannelsForValidation", selectedChannelsForValidation);
        if (selectedChannelsForValidation.length === 0) {
            alert("Please select channel(s) to send notification");
            return;
        }
        clearRecipientsSelection();
        setSelectedChannelsForValidation([]);
        setIsShowChannels(prevState => !prevState);
    };

    // Handler for direct compose (DM) - skips validation since channels are set directly
    const directComposeHandler = () => {
        clearRecipientsSelection();
        setSelectedChannelsForValidation([]);
        setIsShowChannels(false);
    };

    const filterNotificationByChannel = () => {
        setIsChannelFilter(isPoen => !isPoen);
    };

    const deactivateNotificationFilterHandler = () => {
        setIsDeactivateNotificationOpne(prevState => !prevState);
        setIsDeactivateNotificationFilter(preState => !preState);
    };

    // Text field change handler
    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setSearchValue(value);
        applySearchText(value.trim());
    };

    const selectedFiltersString = (selectedChannelFilter.includes("1") ? "Push Notification" : '') +
        (selectedChannelFilter.includes("2") ? ", Email Notification" : '') +
        (selectedChannelFilter.includes("99") ? ", Inactive Notification Thread" : '');

    return (
        <>
            <div className="container messageHead">
                <div className="row">
                    <Col xs={8} md={8}>
                        <div className="channelBox">
                            <button
                                onClick={() => {
                                    setIsShowChannels(!isShowChannels);
                                    setIsChannelFilter(false);
                                }}
                                className={button.btn + ' ' + button.blueButton + ' '}
                            >
                                <IoMdAdd size='20px' style={{ marginRight: '4px' }} /> Create New 
                            </button>
                        </div>
                    </Col>

                    <Col xs={4} md={4} className={button.flex}>
                        <div className="chatbox">
                            <div className="selectfilter" style={{ "position": "relative", "right": "-12px" }}>
                                <button
                                    onClick={() => {
                                        setIsChannelFilter(!isChannelFilter);
                                        setIsShowChannels(false);
                                    }}
                                    className={button.iconType}
                                >
                                    <span className={button.hideBtnText}>Select Channel</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 48 48"
                                        className={button.filtericon}
                                        style={{ width: '22px' }}
                                    >
                                        <g transform="matrix(2,0,0,2,0,0)">
                                            <path d="M21.831 2.808A1.5 1.5 0 0 0 20.5 2h-16a1.5 1.5 0 0 0-1.244 2.339L9 13.293V21a1 1 0 0 0 1.372.929l5-2A1 1 0 0 0 16 19v-5.707l5.729-8.933a1.5 1.5 0 0 0 .102-1.552zm-7.673 9.652A1 1 0 0 0 14 13v5.323l-3 1.2V13a1 1 0 0 0-.158-.54L5.415 4h14.17z"></path>
                                        </g>
                                    </svg>
                                </button>

                                {isChannelFilter && (
                                    <div ref={ref} style={{ display: 'inline-block' }}>
                                        <ChannelFilter
                                            applyChannelFilterHandler={applyChannelFilterHandler}
                                            selectedChannelFilter={selectedChannelFilter}
                                            filterNotificationByChannel={filterNotificationByChannel}
                                            resetChannelFilterHandler={resetChannelFilterHandler}
                                            deactivateNotificationFilterHandler={deactivateNotificationFilterHandler}
                                            isDeactivateNotificationOpne={isDeactivateNotificationOpne}
                                        />
                                    </div>
                                )}

                                <button className={button.iconType}>
                                    <span className={button.hideBtnText}>Sort Listing</span>
                                    {searchFilter && (
                                        <CgClose
                                            className={button.closeFilterSearch}
                                            onClick={closeFilterHandler}
                                        />
                                    )}
                                    {!searchFilter && (
                                        <GrSearch
                                            onClick={openFilterHandler}
                                            className={button.filtericon + ' ' + button.searchFilter}
                                        />
                                    )}
                                </button>
                            </div>
                        </div>
                    </Col>
                </div>

                {isShowChannels && (
                    <div className="row">
                        <Col xs={12} md={12}>
                            <div ref={ref}>
                                <Channels
                                    onComposeChannels={onComposeChannels}
                                    onCompose={selectChannelHandler}
                                    onDirectCompose={directComposeHandler}
                                    checkedChannels={selectedChannels}
                                    setSelectedChannelsForValidation={setSelectedChannelsForValidation}
                                    resetChannelsHandler={resetChannelsHandler}
                                />
                            </div>
                        </Col>
                    </div>
                )}
            </div>

            {selectedChannelFilter.length > 0 && (
                <div className={button.searchNotification}>
                    <div className={button.filterTitle}>
                        <p>
                            <strong>Filters:</strong> {selectedFiltersString}
                        </p>
                        <button
                            type="button"
                            className={button.closeFilter}
                            onClick={clearFilterNotification}
                        >
                            Clear
                        </button>
                    </div>
                </div>
            )}

            {searchFilter && (
                <div className={button.searchNotification}>
                    <div className={button.searchArea}>
                        <input
                            type="search"
                            id="filterSearch"
                            placeholder="Auto Search"
                            value={searchValue}
                            onChange={onSearchHandler}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default NotificationThreadListHeader;

